import { MathUtils, Path, Shape } from "three";
import {
	type ThreeInputLinesType,
	ThreeShapeSideTypes,
	type ThreeSidePathsType,
} from "../../../../../types/three";
import type { DimensionProperties } from "../../../../../types/workpiece";
import type InputType from "../../../Input/InputType";
import { JsonInputType } from "../../../Input/JsonInputType";
import Circle from "../Circle";

export default class Complete extends Circle {
	public static code = "plate_circle_complete";

	public calculateSheetDimensions(input: InputType): { length: number; width: number } | undefined {
		const diameter = Number(input[JsonInputType.Diameter]);

		if (!Number.isNaN(diameter)) {
			return { length: diameter, width: diameter };
		}
	}

	public getThreeShape(props: DimensionProperties["plate_circle_complete"]) {
		const [width] = [props.width / 1000];

		const radius = width / 2;
		const s = new Shape();

		s.moveTo(0, 0);
		s.arc(radius, radius, radius, 0, Math.PI * 2, false);

		return s;
	}

	public getThreeSidePaths(
		props: DimensionProperties["plate_circle_complete"],
	): ThreeSidePathsType[] {
		const [width] = [props.width / 1000];

		return [
			{
				path: new Path()
					.moveTo(0, 0)
					.arc(
						width / 2,
						width / 2,
						width / 2,
						MathUtils.degToRad(0),
						MathUtils.degToRad(360),
						false,
					),
				code: "length1",
				type: ThreeShapeSideTypes.side,
			},
		];
	}

	public getThreeInputLines(
		props: DimensionProperties["plate_circle_complete"],
	): ThreeInputLinesType[] {
		const [width] = [props.width / 1000];

		return [
			{
				dimension: props.width,
				path: new Path().moveTo(0, 0).lineTo(width, 0),
				type: ThreeShapeSideTypes.side,
				code: "width",
			},
		];
	}

	public getDimensions(props: DimensionProperties["plate_circle_complete"]) {
		return {
			width: props.width ? props.width : 1000,
		};
	}
}
